export default __webpack_public_path__ + "static/media/Previous.877da916.svg";